<template>
	<div class="flex flex-col items-center rounded-lg mb-8 mt-10">
		<div class="font-bold text-heading text-5xl text-center">
			Coming Soon
		</div>
		<div class="text-grayscale-body mt-3 text-center">
			{{ props.message }}
		</div>

		<img class="mt-10" src="@/assets/images/illustration/learning_centre_placeholder.svg" alt="Coming Soon"/>

		<SubmitButton :label="buttonText" size="small" class="mt-10" @click="router.push({ name: buttonRoute} )"/>
	</div>
</template>

<script setup lang="js">

import SubmitButton from '@/components/Forms/Buttons/SubmitButton.vue'
import router from '@/router/router.js'

const props = defineProps({
	message: { type: String, default: '' },
	buttonText: { type: String, default: 'Back to Home' },
	buttonRoute: { type: String, default: 'dashboard' },
})

</script>